import React from 'react'
import {
  camelCaseToNormalText,
  formatCamelCaseToTitle,
  formatCartValueConditions,
  formatCartValueConditionsSegments,
} from './constants'
import { Tooltip } from 'antd'
import { CheckAttributeTooltip, formatConditionsSummary } from './TooltipContent'
import usePromotionDetail from 'Components/CJPopover/NodeConfigs/PromotionNode/usePromotionDetail'
import moment from 'moment'
import cronstrue from 'cronstrue'

type NodePreview =
  | 'virtual'
  | 'spingame'
  | 'randomvoucher'
  | 'codedefault'
  | 'entrance'
  | 'wait'
  | 'waitIn'
  | 'promotion'
  | 'coupon'
  | 'createPromotion'
  | 'split'
  | 'checkReachability'
  | 'checkUserAttr'
  | 'checkAudienceSegment'
  | 'web_push'
  | 'sms'
  | 'email'
  | 'popup'
  | 'ol_app'
  | 'appPopup'
  | 'webPopup'
  | 'appInPage'
  | 'webInPage'
  | 'aiCheck'
  | 'outOfPromotion'
  | 'znsByTemplateId'

export default function NodePreview({
  data,
  type,
  audienceName,
}: {
  data: any
  type: string
  audienceName?: string
}) {
  const { promotion: promotionData } = usePromotionDetail(data?.promotionId)

  const renderPreview = React.useMemo(() => {
    switch (type) {
      case 'entrance':
        let cronDescription = ''
        if (data?.schedule) {
          try {
            cronDescription = cronstrue.toString(data.schedule)
          } catch (err: any) {
            cronDescription = `Invalid CRON syntax: ${err.message || 'Unknown error'}`
          }
        }
        return (
          <div>
            <div>{camelCaseToNormalText(data?.channel) || 'All'}</div>
            {cronDescription && (
              <div className="text-secondary_text text-sm">
                Schedule: {cronDescription}
              </div>
            )}
          </div>
        )
      case 'checkAudienceSegment':
        return <div>{audienceName}</div>
      case 'checkUserAttr':
        return (
          <Tooltip 
            title={<CheckAttributeTooltip conditions={data?.segments} />}
            overlayClassName="check-attr-tooltip-overlay"
            placement="top"
          >
            <div className="line-clamp-2 cursor-pointer">
              {formatConditionsSummary(data?.segments)}
            </div>
          </Tooltip>
        )
      case 'checkReachability':
        return <div>{data?.channel}</div>
      case 'wait':
        if (data?.subType === 'durationWait') {
          return (
            <div>
              Wait for {data?.waitTime} {data?.timeFormat}
            </div>
          )
        } else if (data?.subType === 'specificTimeWait') {
          return (
            <div>
              Wait until {data?.time}
            </div>
          )
        } else if (data?.subType === 'dateWait') {
          return (
            <div>
              Wait until {moment(data?.dateTime).format('DD-MM-YYYY HH:MM')}
            </div>
          )
        } else if (data?.subType === 'dayOfWeekWait') {
          return (
            <div>
              Wait until {data?.dayOfWeek}
            </div>
          )
        }
      case 'waitIn':
        return (
          <div>
            <div>
              Wait in for {data?.wait_time} {data?.time_format}
            </div>
            <span className=" line-clamp-1">
              Interaction:{' '}
              <Tooltip title={formatCartValueConditionsSegments(data?.conditions)}>
                {formatCartValueConditionsSegments(data?.conditions)}
              </Tooltip>
            </span>
          </div>
        )
      case 'aiCheck':
        return (
          <div className='line-clamp-2'>
            {formatCamelCaseToTitle(data?.type)} {data?.subType ? `(${data?.subType})` : ''} {data?.promotionType ? `(${data?.promotionType})` : ''}
          </div>
        )
      case 'ol_app':
      case 'appPopup':
      case 'webPopup':
        return (
          <div className=" line-clamp-2">{data?.title || data?.titleContent || data?.type}</div>
        )
      case 'appInPage':
      case 'webInPage':
        return (
          <div className=" line-clamp-2">{data?.title || data?.titleContent || data?.type}</div>
        )
      // case 'web_push':
      //   return <div>Tết gắn kết, trao yêu thương!</div>
      // case 'email':
      //   return (
      //     <div>
      //       <span className=" text-secondary_text ml-0.5">Title: </span>
      //       <span>Cơ hội mua nhóm giá ưu đãi. Đoạn này chỉ show được 2 line</span>
      //     </div>
      //   )
      case 'promotion':
        return (
          <div>
            <div className=" line-clamp-1">{promotionData?.name}</div>
            <span className=" text-secondary_text">End date: </span>
            {data?.dateTime
              ? moment(data?.dateTime)?.format('DD-MM-YYYY HH:MM:SS')
              : data?.wait_time + ' ' + data?.time_format}
          </div>
        )

      case 'coupon':
        return <div className=" line-clamp-2">{promotionData?.name}</div>

      case 'createPromotion':
        return (
          <div>
            {data?.dateTime ? `Expired at ${moment(data?.dateTime)?.format('DD-MM-YYYY HH:MM:SS')}` :
              `Expired in ${data?.wait_time} ${data?.time_format}`
            }
          </div>
        )
      case 'outOfPromotion':
        return <div className=" line-clamp-2">{promotionData?.name}</div>
      case 'znsByTemplateId':
        return <div className=" line-clamp-2">{data?.template_name}</div>
      default:
        return null
    }
  }, [data, promotionData, audienceName])
  return <div className=" text-left text-base mt-3">{renderPreview}</div>
}
